module.exports = kolibriGlobal.coreVue.components.KLabeledIcon;